import { Text } from '@fluentui/react-components';
import CheckoutBox from 'components/core/CheckoutBox/CheckoutBox';
import { useEffect, useMemo, useState } from 'react';
import { GetSessionId } from './Payment.api';
import { Config } from 'config';
import LoadingWheel from 'components/core/LoadingWheel/LoadingWheel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { usePaymentStatus } from 'contexts/PaymentContext/PaymentContext.hooks';
import { usePaymentStyles } from './Payment.styles';
import { MapCreateCartRequest } from 'api/Idi/Idi.api.mapper';
import { useCart } from 'contexts/CartContext/CartContext.hooks';
import { ICreateAndPopulateCartResponse } from '../../../api/Idi/Idi.api.types';
import { SendAppErrorEmail } from 'utils/notifications';

const Payment = () => {
    const styles = usePaymentStyles();

    const [sessionId, setSessionId] = useState<string>();

    const { attempted, status, due, setDue, setIdiCartId } = usePaymentStatus();

    const { cart, setIdiCart } = useCart();

    const iframeUrl = useMemo(() => {
        return sessionId
            ? `${Config.url.TEMPUS_URL}?PAGE=HOSTEDPAYMENT&SESSIONID=${sessionId}`
            : undefined;
    }, [sessionId]);

    useEffect(() => {
        const request = {
            transactionId: 'TestTranIdent',
            referUrl: `${location.origin}/payment`,
            ...MapCreateCartRequest(cart)
        };

        GetSessionId(
            request,
            (response: ICreateAndPopulateCartResponse) => {
                setSessionId(response.paymentResponse.sessionId);
                setDue(response.paymentResponse.amountDue);
                setIdiCartId(response.paymentResponse.cartId);
                setIdiCart(response.idiResponse);
            },
            (reason) => {
                SendAppErrorEmail(
                    'Payment.tsx :: GetSessionId()',
                    `Error occurred retrieving session ID. Reason: ${JSON.stringify(reason)}; Request: ${JSON.stringify(request)}`
                );
                setSessionId(undefined);
            }
        );
    }, []);

    return (
        <div className={styles.root}>
            <CheckoutBox className={styles.info}>
                <Text weight='semibold'>
                    You will be charged Today’s purchase costs Total ${due.toFixed(2)}
                </Text>
                <Text className={styles.note}>
                    Note: You will be setting up payment details for monthly charges separately in
                    billing portal in next steps.
                </Text>
            </CheckoutBox>

            {!status.tranSuccess && (
                <CheckoutBox className={styles.tempusContainer}>
                    <div className={styles.safetySection}>
                        <FontAwesomeIcon icon={faLock} />
                        <Text weight='medium'>Safe and secure encrypted payment.</Text>
                    </div>
                    <div className={styles.tempusFrameContainer}>
                        {iframeUrl ? (
                            <iframe className={styles.tempus} src={iframeUrl} />
                        ) : (
                            <LoadingWheel />
                        )}
                    </div>
                </CheckoutBox>
            )}

            {attempted && !status.tranSuccess && (
                <CheckoutBox className={styles.errorBox}>
                    <FontAwesomeIcon size='2xl' icon={faTriangleExclamation} color={'#DA1E28'} />
                    <Text weight='medium' size={400}>
                        An error has occurred processing your payment, please chat with us online or
                        call us at 1.877.484.2376. We are here to assist you!
                    </Text>
                </CheckoutBox>
            )}
        </div>
    );
};

export default Payment;
